import { render, staticRenderFns } from "./TableauBord.vue?vue&type=template&id=043ed91c&scoped=true"
import script from "./TableauBord.vue?vue&type=script&lang=js"
export * from "./TableauBord.vue?vue&type=script&lang=js"
import style0 from "./TableauBord.vue?vue&type=style&index=0&id=043ed91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043ed91c",
  null
  
)

export default component.exports